import {
    BROADBAND_CODE_PREFIX,
    HW_BUNDLE_LEASE_CODE,
    MBB_BUNDLE_COMMITMENT_CODE,
    OfferingCode,
} from "../models/offeringCodes";

/** Checks if the offering code belongs to a broadband (MBB) subscription */
export const isBroadbandCode = (code?: string): boolean => !!code?.startsWith(BROADBAND_CODE_PREFIX);

/** Checks if the offering code belongs to a handset commitment (lease) subscription */
export const isHandsetWithLeaseCode = (code?: OfferingCode): boolean => !!code?.includes(HW_BUNDLE_LEASE_CODE);

/** Checks if the offering code belongs to an MBB commitment (hardware lease) subscription */
export const isMbbCommitmentCode = (code?: OfferingCode): boolean => !!code?.includes(MBB_BUNDLE_COMMITMENT_CODE);

/** Checks if the offering code is eligible for equipment bundles (handset or MBB commitment) */
export const isEquipmentEligible = (code?: OfferingCode): boolean =>
    isHandsetWithLeaseCode(code) || isMbbCommitmentCode(code);

/** Checks if the offering code belongs to a Telia Trygg (zero-play) subscription */
export const isZeroPlaySubscription = (code?: string): boolean => !!code?.includes("TRYGG");

/** Checks if the offering code belongs to a prepaid (KONTANT) subscription */
export const isPrepaidSubscription = (code?: string): boolean => !!code?.includes("KONTANT");

/** Checks if the offering code belongs to a non-MHS subscription (Telia Trygg, MBB or KONTANT) */
export const isNonMhsSubscription = (code?: string): boolean =>
    isZeroPlaySubscription(code) || isBroadbandCode(code as OfferingCode) || isPrepaidSubscription(code);

export const isMhsSubscription = (code?: string): boolean => !isNonMhsSubscription(code);
